import axios from 'axios';

const STANDARD_OPERATIONS_FORECAST_PATH = '/api/operations-forecast';
const REMOVE_UNITS_PATH = '/remove';

class OperationsForecastService {
  async getOperationsForecast(parameters) {
    const url = STANDARD_OPERATIONS_FORECAST_PATH;
    const operationsForecastResponse = await axios.get(url, {
      params: parameters
    });
    return operationsForecastResponse;
  }

  async removeUnitsFromOpsForecast(parameters) {
    const url = STANDARD_OPERATIONS_FORECAST_PATH + REMOVE_UNITS_PATH;
    const operationsForecastResponse = await axios.post(url, parameters);
    return operationsForecastResponse;
  }
}

export default new OperationsForecastService(); // singleton object
